import React, { Component } from "react";
import {
    MDBBtn,
    MDBModalBody,
    MDBModalHeader,
    MDBSelect,
    MDBSelectInput,
    MDBRow,
    MDBCol,
} from "mdbreact";
import axios from "../../../../axios";
import { DateTimeInput } from "semantic-ui-calendar-react";
import PhoneInput, {
    isPossiblePhoneNumber,
    isValidPhoneNumber,
} from "react-phone-number-input";
import { withTranslation } from "react-i18next";
import $ from "jquery";
import SelectSearch, { fuzzySearch } from "react-select-search";
class AddNewResident extends Component {
    constructor(props) {
        super(props);
        this.handleDayChangeEnd = this.handleDayChangeEnd.bind(this);
        this.dateStartRef = React.createRef();
        this.dateEndRef = React.createRef();
        this.state = {
            Email: "",
            sms: false,
            voice: false,
            dateStartToday: Intl.DateTimeFormat("en-US", {
                month: "2-digit",
                day: "2-digit",
                year: "numeric",
                hour: "numeric",
                minute: "numeric",
            }).format(new Date()),
            dateStart: null,
            dateEnd: "",
            invalidPhone: null,
            invalidDateStart: null,
            loading: false,
            userFound: false,
            userFoundWithPhone: false,
            endDate: null,
            invalidDateEnd: null,
            invalidEmail: null,
            email: "",
            optionTemplateUnits: [],
            optionTemplateBuilding: [],
            optionTemplateFloor: [],
            languageOptions: [
                { value: "en-us", name: "English" },
                { value: "es-xl", name: "Spanish" },
            ],
            loading_units: false,
            duration: this.props.duration
        };
    }
    componentDidUpdate(prevProps, prevState) {
     if (prevProps.hasUpdated !== this.props.hasUpdated) {
      // this.setStartDate(this.props.venueID);
         this.setState({
             unitForm: this.props.unitForm,
             buildingForm: this.props.buildingForm,
             floorForm: this.props.floorForm,
         });
     }
     if (prevProps.hasUpdatedUnit !== this.props.hasUpdatedUnit) {
         this.setState({
             selectedUnit: this.props.selectedUnit,
             buildingForm: this.props.buildingForm,
         });
     }
     if (prevProps.hasUpdatedBuilding !== this.props.hasUpdatedBuilding) {
         this.setState({
             selectedBuilding: this.props.selectedBuilding,
             floorForm: this.props.floorForm,
         });
     }
     if (prevProps.hasUpdatedFloor !== this.props.hasUpdatedFloor) {
         this.setState({
             selectedFloor: this.props.selectedFloor,
             unitID_internal: this.props.unitID_internal,
         });
     }
     // Check if duration and timezone are available and set start date
     console.log('componentDidUpdate - duration:', this.props.duration, 'timezone:', this.props.timezone, 'dateStart:', this.state.dateStart);
     console.log('prevProps duration:', prevProps.duration, 'prevProps timezone:', prevProps.timezone);
     if (this.props.duration !== undefined && this.props.timezone !== undefined && 
         (prevProps.duration !== this.props.duration || 
          prevProps.timezone !== this.props.timezone ||
          !this.state.dateStart)) {
      console.log('Setting start date with duration:', this.props.duration)
      this.setState({ duration: this.props.duration }, () => {
       this.setStartDate();
      });
     }
     // Auto-select building if there's only one option (checking both props and state)
     if (
      ((prevProps.optionTemplateBuilding !== this.props.optionTemplateBuilding &&
       this.props.optionTemplateBuilding &&
       this.props.optionTemplateBuilding.length === 1 &&
       !this.props.selectedBuilding) ||
      (prevState?.optionTemplateBuilding !== this.state.optionTemplateBuilding &&
       this.state.optionTemplateBuilding &&
       this.state.optionTemplateBuilding.length === 1 &&
       !this.state.selectedBuilding))
     ) {
      const buildingValue = this.props.optionTemplateBuilding?.[0]?.value || this.state.optionTemplateBuilding?.[0]?.value;
      if (buildingValue && this.state.unitData && this.state.selectedUnit) {
       setTimeout(() => {
        this.handleSelectChangeBuilding(buildingValue);
       }, 10);
      }
     }
     // Auto-select floor if there's only one option (checking both props and state)
     if (
      ((prevProps.optionTemplateFloor !== this.props.optionTemplateFloor &&
       this.props.optionTemplateFloor &&
       this.props.optionTemplateFloor.length === 1 &&
       !this.props.selectedFloor) ||
      (prevState?.optionTemplateFloor !== this.state.optionTemplateFloor &&
       this.state.optionTemplateFloor &&
       this.state.optionTemplateFloor.length === 1 &&
       !this.state.selectedFloor))
     ) {
      const floorValue = this.props.optionTemplateFloor?.[0]?.value || this.state.optionTemplateFloor?.[0]?.value;
      if (floorValue && this.state.unitData && this.state.selectedUnit && this.state.selectedBuilding) {
       setTimeout(() => {
        this.handleSelectChangeFloor(floorValue);
       }, 10);
      }
     }
 }
    // Prevent keyboard input on date fields - only allow calendar selection
    preventDateKeyboardInput = (e) => {
        // Allow tab for accessibility
        if (e.key === 'Tab') {
            return true;
        }
        // Prevent all other keyboard input
        e.preventDefault();
        return false;
    };
    validateEmail = (emailEntered) => {
        var mailformat = /^[\w._-]+[+]?[\w._-]+@[\w.-]+\.[a-zA-Z]{2,6}$/;
        this.setState({
            invalidPhone: undefined,
            userFound: false,
            userFoundWithPhone: false,
        });
        let email = emailEntered.trim();
        if (!email.match(mailformat)) {
            this.setState({
                invalidEmail: "Please provide a valid email address",
            });
            $(".emailInput").addClass("is-invalid");
        } else {
            this.setState({ invalidEmail: undefined });
            $(".emailInput").removeClass("is-invalid");
        }
        this.setState({ loading: true });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            EmailAddress: email,
            VenueID: this.props.venueID,
        };
        axios
            .post("/venuemgmtconsole/subscribers/validateEmailAddress", body, {
                headers: {},
            })
            .then((response) => {
                this.setState({
                    firstName: response.data.GivenName,
                    lastName: response.data.FamilyName,
                    selectedLanguage: response.data.locale,
                    invalidPhone: undefined,
                    userFound: true,
                });
                if (response.data["PhoneNumber.E164"] === "") {
                    this.setState({ userFoundWithPhone: false });
                } else {
                    this.setState({
                        phoneNumber: response.data["PhoneNumber.E164"],
                        userFoundWithPhone: true,
                    });
                }
                this.setState({ loading: false });
            })
            .catch((error) => {
                this.setState({ error: true });
                this.setState({ loading: false });
                this.setState({ userFound: false });
            });
    };
    setStartDate = (index) => {
     // let body = {
     //             AccessToken: sessionStorage.getItem("AccessToken"),
     //             VenueID: index,
     //             UserTimeZone: new Date().getTimezoneOffset(),
     //         };
     //         axios
     //             .post("/venuemgmtconsole/venues/listVenueDetails", body, {
     //                 headers: {},
     //             })
     //             .then((response) => {
     var offset =
                    (new Date().getTimezoneOffset() +
                        this.props.timezone * 60) *
                    60 *
                    1000;
                    console.log("Offset: ", offset)
                let offsetTimestamp = new Date().getTime() + offset;
                let offsetDateStart = new Date(offsetTimestamp);
                this.setState({
                    dateStart: Intl.DateTimeFormat("en-US", {
                        month: "2-digit",
                        day: "2-digit",
                        year: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                    }).format(offsetDateStart),
                });
                let offsetTimestampNow = new Date().getTime() + offset;
                let offsetDateStartNow = new Date(offsetTimestampNow);
                this.setState({
                    dateStart: Intl.DateTimeFormat("en-US", {
                        month: "2-digit",
                        day: "2-digit",
                        year: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                    }).format(offsetDateStart),
                });
                this.setState({
                    dateStartNow: Intl.DateTimeFormat("en-US", {
                        month: "2-digit",
                        day: "2-digit",
                        year: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                    }).format(offsetDateStartNow),
                });
               // })
    }
    getVenueDetails = (index) => {
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            VenueID: index,
            UserTimeZone: new Date().getTimezoneOffset(),
        };
        this.setState({
            unitData: undefined,
            expiringData: undefined,
            searchData: undefined,
            value: "",
            loading_units: true,
            duration: undefined,
        });
        axios
            .post("/venuemgmtconsole/venues/listVenueDetails", body, {
                headers: {},
            })
            .then((response) => {
                this.setState({
                    unitData:
                        response.data[index][
                            "Units-Building-Floor-List-GuestNetworks"
                        ],
                    timezone: response.data[index]["TimeZoneOffset"], //+4
                    duration:
                        response.data[index][
                            "DefaultSubscriptionDurationHours_LocalWirelessAccess"
                        ],
                });
                let optionTemplateUnits = [];
                Object.keys(
                    response.data[index][
                        "Units-Building-Floor-List-GuestNetworks"
                    ]
                ).map((oneKey, i) => {
                    optionTemplateUnits.push({ value: oneKey, name: oneKey });
                    return true;
                });
                this.setState({
                    optionTemplateUnits: optionTemplateUnits,
                    loading_units: false,
                });
                var offset =
                    (new Date().getTimezoneOffset() +
                        response.data[index]["TimeZoneOffset"] * 60) *
                    60 *
                    1000;
                let offsetTimestamp = new Date().getTime() + offset;
                let offsetDateStart = new Date(offsetTimestamp);
                this.setState({
                    dateStart: Intl.DateTimeFormat("en-US", {
                        month: "2-digit",
                        day: "2-digit",
                        year: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                    }).format(offsetDateStart),
                });
                let offsetTimestampNow = new Date().getTime() + offset;
                let offsetDateStartNow = new Date(offsetTimestampNow);
                this.setState({
                    dateStart: Intl.DateTimeFormat("en-US", {
                        month: "2-digit",
                        day: "2-digit",
                        year: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                    }).format(offsetDateStart),
                });
                this.setState({
                    dateStartNow: Intl.DateTimeFormat("en-US", {
                        month: "2-digit",
                        day: "2-digit",
                        year: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                    }).format(offsetDateStartNow),
                });
            })
            .catch((error) => {
                this.getVenueDetails(index);
                this.setState({
                    error: true,
                    loading_units: false,
                });
            });
    };
    resetBuildingForm = (value) => {
        this.setState({
            buildingForm: (
                <MDBSelect
                    id="selectBuilding"
                    getValue={this.handleSelectChangeBuilding}
                    className="form-control"
                >
                    <MDBSelectInput
                        className="selectInput selectBuilding"
                        selected="Choose your building"
                    />
                </MDBSelect>
            ),
        });
        this.setState({
            floorForm: (
                <MDBSelect
                    id="selectFloor"
                    getValue={this.handleSelectChangeFloor}
                    className="form-control"
                >
                    <MDBSelectInput
                        className="selectInput selectFloor"
                        selected="Choose your floor"
                    />
                </MDBSelect>
            ),
        });
        setTimeout(() => {
            this.handleSelectChangeUnit(value);
        }, 1);
    };
    handleSelectChangeUnit = (value) => {
        this.setState({
            selectedUnit: value,
            optionTemplateFloor: [],
            selectedBuilding: undefined,
            selectedFloor: undefined,
        });
        let optionTemplateBuilding = [];
        Object.keys(this.state.unitData[value]).map((oneKey, i) => {
            if (oneKey === "DEFAULT") {
                optionTemplateBuilding.push({ value: oneKey, name: oneKey });
            } else {
                optionTemplateBuilding.push({ value: oneKey, name: oneKey });
            }
            return true;
        });
        this.setState({
            optionTemplateBuilding: optionTemplateBuilding,
        }, () => {
            // Auto-select building if there's only one option
            if (optionTemplateBuilding.length === 1) {
                setTimeout(() => {
                    this.handleSelectChangeBuilding(optionTemplateBuilding[0].value);
                }, 50);
            }
        });
    };
    resetFloorForm = (value) => {
        setTimeout(() => {
            this.handleSelectChangeBuilding(value);
        }, 1);
    };
    handleSelectChangeBuilding = (value) => {
        this.setState({ selectedBuilding: value });
        let optionTemplateFloor = [];
        Object.keys(this.state.unitData[this.state.selectedUnit][value]).map(
            (oneKey, i) => {
                if (oneKey === "DEFAULT") {
                    optionTemplateFloor.push({ value: oneKey, name: oneKey });
                } else {
                    optionTemplateFloor.push({ value: oneKey, name: oneKey });
                }
                return true;
            }
        );
        this.setState({
            optionTemplateFloor: optionTemplateFloor,
        }, () => {
            // Auto-select floor if there's only one option
            if (optionTemplateFloor.length === 1) {
                setTimeout(() => {
                    this.handleSelectChangeFloor(optionTemplateFloor[0].value);
                }, 50);
            }
        });
    };
    handleSelectChangeFloor = (value) => {
        this.setState({
            selectedFloor: value,
            unitID_internal:
                this.state.unitData[this.state.selectedUnit][
                    this.state.selectedBuilding
                ][value]["UnitID_internal"],
        });
    };
    handleSelectChangeLanguage = (value) => {
        this.setState({ selectedLanguage: value });
    };
    submitHandler = (event) => {
        event.preventDefault();
        event.target.className += " was-validated";
        $("#selectUnit").removeClass("is-invalid");
        $("#selectBuilding").removeClass("is-invalid");
        $("#selectFloor").removeClass("is-invalid");
        $("#selectLanguage").removeClass("is-invalid");
        if (this.props.selectedUnit === undefined) {
            this.setState({ invalidUnit: "Please provide a valid unit" });
            $("#selectUnit").addClass("is-invalid");
        } else {
            $("#selectUnit").addClass("is-valid");
        }
        if (this.props.selectedBuilding === undefined) {
            this.setState({ invalidBuilding: "Please provide a valid unit" });
            $("#selectBuilding").addClass("is-invalid");
        } else {
            $("#selectBuilding").addClass("is-valid");
        }
        if (this.props.selectedFloor === undefined) {
            this.setState({ invalidFloor: "Please provide a valid floor" });
            $("#selectFloor").addClass("is-invalid");
        } else {
            $("#selectFloor").addClass("is-valid");
        }
        if (this.state.selectedLanguage === undefined) {
            this.setState({
                invalidLanguage: "Please provide a valid language",
            });
            $("#selectLanguage").addClass("is-invalid");
        } else {
            $("#selectLanguage").addClass("is-valid");
        }
        if (this.state.email === undefined) {
            this.setState({
                invalidEmail: "Please provide a valid email address",
            });
        }
        if (
            this.state.invalidPhone === null ||
            this.state.invalidPhone !== undefined
        ) {
            this.setState({
                invalidPhone: "Please provide a valid phone number",
            });
            $(".PhoneInput").addClass("is-invalid");
        } else {
            $(".PhoneInput").addClass("is-valid");
        }
        const startDateError = this.validateDateTime(this.state.dateStart);
        const endDateError = this.validateDateTime(this.state.dateEnd);
        if (startDateError) {
            this.setState({ invalidDateStart: startDateError });
        }
        if (endDateError) {
            this.setState({ invalidDateEnd: endDateError });
        }
        if (
            this.state.invalidEmail === undefined &&
            this.state.firstName !== undefined &&
            this.state.lastName !== undefined &&
            this.state.selectedLanguage !== undefined &&
            this.props.selectedUnit !== undefined &&
            this.props.selectedBuilding !== undefined &&
            this.props.selectedFloor !== undefined &&
            !startDateError &&
            !endDateError
        ) {
            this.props.submitHandlerGuest(
                this.props.venueID,
                this.state.dateEnd,
                this.state.email.trim(),
                this.state.firstName.trim(),
                this.state.lastName.trim(),
                this.state.phoneNumber,
                this.state.selectedLanguage,
                this.props.selectedUnit,
                this.props.selectedBuilding,
                this.props.selectedFloor,
                this.state.dateStart,
                this.props.unitID_internal,
                true
            );
        }
    };
    toggleCheckboxValueSMS = () => {
        this.setState({ sms: !this.state.sms });
    };
    toggleCheckboxValueVoice = () => {
        this.setState({ voice: !this.state.voice });
    };
    changeHandler = (event) => {
        this.closeDatePicker();
        this.setState({ [event.target.name]: event.target.value });
    };
    closeDatePicker = () => {
        // Close the date pickers by removing focus
        if (this.dateStartRef.current) {
            const input = this.dateStartRef.current.querySelector('input');
            if (input) {
                input.blur();
            }
        }
        if (this.dateEndRef.current) {
            const input = this.dateEndRef.current.querySelector('input');
            if (input) {
                input.blur();
            }
        }
    };
    changeHandlerPhone = (event) => {
        this.closeDatePicker();
        this.setState({ phoneNumber: event });
        var value = event
            ? isPossiblePhoneNumber(event)
                ? undefined
                : "Please provide a valid phone number"
            : "Phone number required";
        this.setState({ invalidPhone: value });
    };
    createMask = () => {
        this.setState({
            phoneNumber: this.state.phoneNumber.replace(/\D/g, ""),
        });
    };
    handleDayChangeEnd = (event, { name, value }) => {
        console.log('handleDayChangeEnd called:', name, value);
        if (this.state.hasOwnProperty(name)) {
            this.setState({ [name]: value }, () => {
                console.log('State updated:', name, this.state[name]);
            });
        }
        var isISO = value;
        if (new Date(isISO) > new Date(this.state.maxDate)) {
            this.setState({
                invalidDateEnd: "Date cannot exceed 5 days for a Guest",
            });
        } else {
            if (isNaN(new Date(isISO)) === false) {
                this.setState({ invalidDateEnd: null });
            } else {
                this.setState({
                    invalidDateEnd:
                        "Please provide a valid date in this format MM/DD/YYYY H:MM AM/PM",
                });
            }
        }
    };
    validateDateTime = (value) => {
        if (!value || value.trim() === "") {
            return null;
        }
        if (/[^0-9/:, APM]/.test(value)) {
            return "Invalid characters in date/time";
        }
        if (!/^\d{2}\/\d{2}\/\d{4}, \d{1,2}:\d{2} [AP]M$/.test(value)) {
            return "Date must be in MM/DD/YYYY, h:mm AM/PM format";
        }
        const parts = value.split(", ");
        const dateParts = parts[0].split("/");
        const timeParts = parts[1].split(" ");
        const [hours, minutes] = timeParts[0].split(":");
        const period = timeParts[1];
        const month = parseInt(dateParts[0], 10);
        const day = parseInt(dateParts[1], 10);
        const year = parseInt(dateParts[2], 10);
        const hour = parseInt(hours, 10);
        const minute = parseInt(minutes, 10);
        if (month < 1 || month > 12) {
            return "Month must be between 01 and 12";
        }
        if (day < 1 || day > 31) {
            return "Day must be between 01 and 31";
        }
        if (year < 2000 || year > 2099) {
            return "Year must be between 2000 and 2099";
        }
        if (hour < 1 || hour > 12) {
            return "Hour must be between 1 and 12";
        }
        if (minute < 0 || minute > 59) {
            return "Minute must be between 00 and 59";
        }
        if (period !== "AM" && period !== "PM") {
            return "Time must end with AM or PM";
        }
        const dateObj = new Date(year, month - 1, day);
        if (
            dateObj.getFullYear() !== year ||
            dateObj.getMonth() !== month - 1 ||
            dateObj.getDate() !== day
        ) {
            return "Invalid date";
        }
        // Check if date/time is in the past
        let hour24 = hour;
        if (period === "PM" && hour !== 12) {
            hour24 = hour + 12;
        } else if (period === "AM" && hour === 12) {
            hour24 = 0;
        }
        const dateTimeObj = new Date(year, month - 1, day, hour24, minute);
        const now = new Date();
        if (dateTimeObj < now) {
            return "Date/time cannot be in the past";
        }
        return null;
    };
    validateDateTimeOnBlur = (name) => {
        const value = this.state[name];
        const error = this.validateDateTime(value);
        if (name === "dateStart") {
            this.setState({ invalidDateStart: error });
        } else if (name === "dateEnd") {
            if (!error && value && this.state.dateStart) {
                const startDate = new Date(this.state.dateStart);
                const endDate = new Date(value);
                if (endDate <= startDate) {
                    this.setState({
                        invalidDateEnd:
                            "End date must be after start date",
                    });
                    return;
                }
            }
            this.setState({ invalidDateEnd: error });
        }
    };
    handleChange = (event, { name, value }) => {
        console.log('handleChange called:', name, value);
        if (this.state.hasOwnProperty(name)) {
            if (name === "dateStart" || name === "dateEnd") {
                const cleaned = value.replace(/[^0-9/:, APM]/g, "");
                this.setState({ [name]: cleaned });
                if (value !== cleaned) {
                    this.setState({
                        [name === "dateStart"
                            ? "invalidDateStart"
                            : "invalidDateEnd"]:
                            "Invalid characters in date/time",
                    });
                } else {
                    const error = this.validateDateTime(cleaned);
                    if (!error || cleaned.length < 20) {
                        this.setState({
                            [name === "dateStart"
                                ? "invalidDateStart"
                                : "invalidDateEnd"]: cleaned.length >= 20 ? error : null,
                        });
                    }
                }
            } else {
                this.setState({ [name]: value });
            }
        }
    };
    render() {
     console.log('Render - dateStart:', this.state.dateStart)
     console.log(this.props)
     console.log(this.state)
        const { t } = this.props;
        const FORMAT = "MM/dd/yyyy";
        return (
            <>
                {this.state.loading_units === true ? (
                    <div id="overlay" style={{ display: "block" }}>
                        <div className="overlayMessage">
                            <div
                                className="spinner-border spinner-border"
                                role="status"
                            >
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                ) : (
                    ""
                )}
                <MDBModalHeader toggle={this.props.toggleAddNewGuest}>
                    <h4>
                        {this.props.venueType === "HOTSPOT"
                            ? "Add New Subscriber"
                            : t("addnewguest.title")}
                    </h4>
                    <p>{t("addnewresident.required")}</p>
                </MDBModalHeader>
                <MDBModalBody>
                    <form
                        className="needs-validation"
                        onSubmit={this.submitHandler}
                        noValidate
                        id="form2"
                    >
                     <MDBRow>
                            <MDBCol col="6" sm="12" lg="12">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    Venue Name
                                </label>
                                <SelectSearch
                                    id="selectVenue"
                                    search={true}
                                    filterOptions={fuzzySearch}
                                    options={this.props.optionTemplateVenues}
                                    isOptionSelected={true}
                                    inputId="venueArray"
                                    classNamePrefix="venue-select"
                                    placeholder="Select..."
                                    onChange={
                                        this.props.handleSelectChangeVenue
                                    }
                                    value={
                                        this.props.clearDropDown === true
                                            ? ""
                                            : this.props.venueID
                                    }
                                />
                                <div className="invalid-feedback">
                                    Please select a venue.
                                </div>
                            </MDBCol>
                            <MDBCol col="6"></MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol col="6" sm="12" lg="6">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    {t("addnewresident.email")}
                                </label>
                                <input
                                    required
                                    id="email"
                                    className="form-control emailInput"
                                    onFocus={this.closeDatePicker}
                                    onBlur={(event) =>
                                        this.validateEmail(this.state.email)
                                    }
                                    onChange={(event) =>
                                        this.setState({
                                            email: event.target.value,
                                        })
                                    }
                                    value={this.state.email}
                                    error={
                                        this.state.invalidEmail !== undefined
                                            ? "Invalid email address"
                                            : "Email address required"
                                    }
                                />
                                {this.state.invalidEmail !== undefined ? (
                                    <div className="invalid">
                                        {this.state.invalidEmail}
                                    </div>
                                ) : (
                                    ""
                                )}
                            </MDBCol>
                            <MDBCol col="6"></MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol sm="12" lg="6">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    {t("addnewresident.firstname")}
                                </label>
                                <input
                                    required
                                    name="firstName"
                                    id="firstName"
                                    className={
                                        this.state.loading === true
                                            ? "form-control loading"
                                            : "form-control"
                                    }
                                    onChange={this.changeHandler}
                                    value={this.state.firstName}
                                    disabled={this.state.userFound}
                                />
                                <div className="invalid-feedback">
                                    Please provide a valid first name.
                                </div>
                            </MDBCol>
                            <MDBCol sm="12" lg="6">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    {t("addnewresident.lastname")}
                                </label>
                                <input
                                    required
                                    className={
                                        this.state.loading === true
                                            ? "form-control loading"
                                            : "form-control"
                                    }
                                    name="lastName"
                                    id="lastName"
                                    onChange={this.changeHandler}
                                    value={this.state.lastName}
                                    disabled={this.state.userFound}
                                />
                                <div className="invalid-feedback">
                                    Please provide a valid last name.
                                </div>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol col="6" sm="12" lg="6">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    {t("addnewguest.phone")}
                                </label>
                                <PhoneInput
                                    placeholder={t("addnewresident.enterphone")}
                                    value={this.state.phoneNumber}
                                    format={FORMAT}
                                    onChange={this.changeHandlerPhone}
                                    name="phoneNumber"
                                    id="phoneNumber"
                                    className={
                                        this.state.loading === true
                                            ? "form-control loading"
                                            : "form-control"
                                    }
                                    defaultCountry="US"
                                    required
                                    error={
                                        this.state.phoneNumber
                                            ? isValidPhoneNumber(
                                                  this.state.phoneNumber
                                              )
                                                ? undefined
                                                : "Invalid phone number"
                                            : "Phone number required"
                                    }
                                    disabled={this.state.userFoundWithPhone}
                                />
                                {this.state.invalidPhone !== null ? (
                                    <div className="invalid">
                                        {this.state.invalidPhone}
                                    </div>
                                ) : (
                                    ""
                                )}
                            </MDBCol>
                            <MDBCol col="6">
                                <div>
                                    <label
                                        htmlFor="defaultFormLoginEmailEx"
                                        className="black-text"
                                    >
                                        {t("addnewresident.language")}
                                    </label>
                                    <SelectSearch
                                        id="selectLanguage"
                                        search={true}
                                        filterOptions={fuzzySearch}
                                        options={this.state.languageOptions}
                                        isOptionSelected={true}
                                        classNamePrefix="language-select"
                                        onChange={
                                            this.handleSelectChangeLanguage
                                        }
                                        value={this.state.selectedLanguage}
                                        placeholder={
                                            this.state.selectedLanguage !==
                                            undefined
                                                ? this.state
                                                      .selectedLanguage ===
                                                  "en-us"
                                                    ? "English"
                                                    : "Spanish"
                                                : "Select..."
                                        }
                                    />
                                    <div className="invalid-feedback">
                                        Please provide a valid language.
                                    </div>
                                </div>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol col="6" sm="12" lg="6">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    {this.props.venueType === "HOTSPOT"
                                        ? "Subscriber Network *"
                                        : t("addnewguest.unit")}
                                </label>
                                <SelectSearch
                                    id="selectUnit"
                                    search={true}
                                    filterOptions={fuzzySearch}
                                    options={this.props.optionTemplateGuestUnits}
                                    onChange={this.props.handleSelectChangeUnit}
                                    isOptionSelected={true}
                                    inputId="unitArray"
                                    classNamePrefix="unit-select form-control"
                                    placeholder="Select..."
                                    value={this.props.selectedUnit}
                                />
                                <div className="invalid-feedback">
                                    Please provide a unit number.
                                </div>
                            </MDBCol>
                            <MDBCol col="6"></MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol col="6">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    {t("addnewresident.building")}
                                </label>
                                <SelectSearch
                                    id="selectBuilding"
                                    options={this.props.optionTemplateBuilding}
                                    search={true}
                                    filterOptions={fuzzySearch}
                                    onChange={this.props.handleSelectChangeBuilding}
                                    isOptionSelected={true}
                                    inputId="buildingArray"
                                    classNamePrefix="building-select"
                                    placeholder="Select..."
                                    value={this.props.selectedBuilding}
                                />
                                <div className="invalid-feedback">
                                    Please provide a building.
                                </div>
                            </MDBCol>
                            <MDBCol col="6">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    {t("addnewresident.floor")}
                                </label>
                                <SelectSearch
                                    ref={this.floorSelect}
                                    id="selectFloor"
                                    search={true}
                                    filterOptions={fuzzySearch}
                                    options={this.props.optionTemplateFloor}
                                    onChange={this.props.handleSelectChangeFloor}
                                    isOptionSelected={true}
                                    inputId="floorArray"
                                    classNamePrefix="floo-select"
                                    placeholder="Select..."
                                    emptyMessage="Select..."
                                    value={this.props.selectedFloor}
                                />
                                <div className="invalid-feedback">
                                    Please provide a floor.
                                </div>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol sm="12" lg="6">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    {t("addnewresident.servicestart")}
                                </label>
                                <br />
                                <div ref={this.dateStartRef}>
                                <DateTimeInput
                                    dateTimeFormat="MM/DD/YYYY, h:mm A"
                                    timeFormat="ampm"
                                    name="dateStart"
                                    placeholder="MM/DD/YYYY"
                                    value={this.state.dateStart}
                                    iconPosition="left"
                                    onChange={this.handleChange}
                                    onBlur={() =>
                                        this.validateDateTimeOnBlur("dateStart")
                                    }
                                    onKeyDown={this.preventDateKeyboardInput}
                                    className={"dateTimePicker" + (this.state.invalidDateStart ? " error" : "")}
                                    closable={true}
                                    disableMinute="true"
                                    minDate={this.props.dateStartNow}
                                    maxDate={new Date(this.state.maxDate)}
                                />
                                </div>
                                {this.state.invalidDateStart && (
                                    <div className="invalid" style={{ color: "red", fontSize: "12px" }}>
                                        {this.state.invalidDateStart}
                                    </div>
                                )}
                                <label
                                    for="serviceStart"
                                    className="black-text"
                                    style={{
                                        fontSize: "11px",
                                        position: "relative",
                                        top: this.state.invalidDateStart ? "0px" : "-5px",
                                        left: "0px",
                                    }}
                                >
                                    {this.props.venueType === "HOTSPOT"
                                        ? "Subscriber can use their Wi-Fi password as of this date"
                                        : t("addnewguest.servicestartlabel")}
                                </label>
                                {this.state.invalidDate !== null ? (
                                    <div className="invalid">
                                        {this.state.invalidDate}
                                    </div>
                                ) : (
                                    ""
                                )}
                            </MDBCol>
                            <MDBCol sm="12" lg="6">
                                <label
                                    htmlFor="defaultFormLoginEmailEx"
                                    className="black-text"
                                >
                                    {t("addnewresident.serviceend")}
                                </label>
                                <br />
                                <div ref={this.dateEndRef}>
                                <DateTimeInput
                                    dateTimeFormat="MM/DD/YYYY, h:mm A"
                                    timeFormat="ampm"
                                    name="dateEnd"
                                    placeholder="MM/DD/YYYY"
                                    value={this.state.dateEnd}
                                    iconPosition="left"
                                    onChange={this.handleChange}
                                    onBlur={() =>
                                        this.validateDateTimeOnBlur("dateEnd")
                                    }
                                    onKeyDown={this.preventDateKeyboardInput}
                                    className={"dateTimePicker" + (this.state.invalidDateEnd ? " error" : "")}
                                    closable={true}
                                    disableMinute="true"
                                    maxDate={
                                        this.state.duration === 0
                                            ? "0"
                                            : new Date(this.state.maxDate)
                                    }
                                    minDate={this.state.dateStart || this.props.dateStartNow}
                                    initialDate={this.state.dateStart || this.props.dateStartNow}
                            
                                />
                                </div>
                                <label
                                    className="black-text"
                                    style={{
                                        fontSize: "11px",
                                        position: "relative",
                                        top: this.state.invalidDateEnd ? "0px" : "-5px",
                                        left: "0px",
                                    }}
                                >
                                    {t("addnewguest.serviceendlabel")}
                                </label>
                                {this.state.invalidDateEnd !== null ? (
                                    <div className="invalid">
                                        {this.state.invalidDateEnd}
                                    </div>
                                ) : (
                                    ""
                                )}
                            </MDBCol>
                        </MDBRow>
                        <div className="text-right submitButton">
                            <MDBBtn color="danger" type="submit">
                                {this.props.loading === true ? (
                                    <div
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                    >
                                        <span className="sr-only">
                                            Loading...
                                        </span>
                                    </div>
                                ) : this.props.venueType === "HOTSPOT" ? (
                                    "Add Subscriber"
                                ) : (
                                    t("addnewguest.addguest")
                                )}
                            </MDBBtn>
                        </div>
                    </form>
                </MDBModalBody>
            </>
        );
    }
}
export default withTranslation()(AddNewResident);
